import { Checkbox, FormControlLabel, Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { ActivityGranularity } from './periodChart';

// The horizon toggle names the window; each window has its own period length:
// trailing 7 days by day, the last quarter by week, the last year by month.
const ACTIVITY_HORIZONS: { value: ActivityGranularity; label: string }[] = [
  { value: 'day', label: '7 Days' },
  { value: 'week', label: '13 Weeks' },
  { value: 'month', label: '12 Months' },
];

type ActivityHorizonControlsProps = {
  // Unit of the bars, shown beside the controls from sm up.
  caption: string;
  granularity: ActivityGranularity;
  onGranularity: (granularity: ActivityGranularity) => void;
  showTrend: boolean;
  onShowTrend: (showTrend: boolean) => void;
};

// Card-header controls for the period charts: the unit caption, the Trend
// checkbox and the horizon toggle, in that order left to right.
export const ActivityHorizonControls = ({ caption, granularity, onGranularity, showTrend, onShowTrend }: ActivityHorizonControlsProps): ReactElement => (
  <Stack direction="row" alignItems="center" spacing={1.5}>
    <Typography variant="caption" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
      {caption}
    </Typography>
    <FormControlLabel
      label="Trend"
      control={<Checkbox size="small" checked={showTrend} onChange={(event) => onShowTrend(event.target.checked)} sx={{ p: 0.5 }} />}
      slotProps={{ typography: { variant: 'caption', color: 'text.secondary' } }}
      sx={{ mr: 0 }}
    />
    <ToggleButtonGroup size="small" exclusive value={granularity} onChange={(_event, value: ActivityGranularity | null) => value && onGranularity(value)}>
      {ACTIVITY_HORIZONS.map((h) => (
        <ToggleButton key={h.value} value={h.value}>
          {h.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  </Stack>
);
